<div class="assessment-manager-view" *ngIf="assessment">
  <div class="header">
    <div>
      <h2>Assessment Manager – View</h2>
      <div class="subtitle">Assessment: {{assessment.assessmentName}}</div>
    </div>
    <div class="actions">
      <button pButton type="button" class="p-button-text" label="Back to List" (click)="backToList()"></button>
      <button pButton type="button" icon="pi pi-pencil" label="Edit Assessment" (click)="editAssessment()"></button>
    </div>
  </div>

  <div class="detail-grid">
    <div><span class="label">Lead:</span> {{assessment.lead?.fullName || assessment.lead?.emailAddress || '—'}}</div>
    <div><span class="label">Period:</span> {{assessment.startDate | date:'shortDate'}} - {{assessment.endDate | date:'shortDate'}}</div>
    <div><span class="label">Status:</span> {{assessment.status === 0 ? 'Active' : 'Closed'}}</div>
  </div>

  <p-table [value]="assessment.controls" dataKey="assessmentControlId">
    <ng-template pTemplate="header">
      <tr>
        <th>Control ID</th>
        <th>Control Short Name</th>
        <th>Status</th>
        <th>Due</th>
        <th>Assessor</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr (click)="openControl(row)">
        <td>{{row.controlId}}</td>
        <td>{{row.controlShortName}}</td>
        <td (click)="$event.stopPropagation()">
          <p-select [options]="controlStatusOptions" optionLabel="label" optionValue="value"
                      [(ngModel)]="row.status" (onChange)="saveControl(row)"></p-select>
        </td>
        <td (click)="$event.stopPropagation()">
          <p-date-picker [(ngModel)]="row.dueDate" appendTo="body" dateFormat="mm/dd/yy" (onSelect)="saveControl(row)"
                      (onBlur)="saveControl(row)"></p-date-picker>
        </td>
        <td (click)="$event.stopPropagation()">
          <p-select [options]="assessors" optionLabel="fullName" optionValue="userId"
                      [(ngModel)]="row.assessorUserId" placeholder="Select" (onChange)="saveControl(row)" appendTo="body" ></p-select>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
